import type { RuleDefinition } from '../domain/types';
import { getCellText } from '../domain/cells';
import { getFieldDefinition } from '../domain/fields';
import { parseNumeric } from '../utils/number';
import { NUMERIC_FIELDS, cellValueForParsing, finding, isFormulaWithoutResult } from './helpers';

export const BQ006: RuleDefinition = {
  id: 'BQ006',
  name: '非正常负值',
  description: '提醒工程量、综合单价或合价中的负值。',
  defaultSeverity: 'error',
  enabled: true,
  applicableFields: NUMERIC_FIELDS,
  message: '数值小于零，可能存在符号或数据口径问题。',
  suggestion: '请结合原始计价依据核对负值是否符合当前清单业务口径。',
  check: ({ detailRows }) =>
    detailRows.flatMap((row) =>
      NUMERIC_FIELDS.flatMap((field) => {
        if (isFormulaWithoutResult(row, field)) return [];
        const parsed = parseNumeric(cellValueForParsing(row, field));
        if (!parsed.ok || !parsed.decimal.isNegative()) return [];
        return [
          finding(row, field, {
            currentValue: getCellText(row, field),
            message: `${getFieldDefinition(field).label}为负值。`,
          }),
        ];
      }),
    ),
};
